module.exports = __webpack_public_path__ + "static/media/fig_16.29b05ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_16.jpg
// module id = 646
// module chunks = 0